function fetchResults(id, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/availability/${id}`;
  return apiClient.get(route);
}

function fetchHoldingsProbes(id, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/bibs/holdings/probes/${id}`;
  return apiClient.get(route);
}

export default {
  fetchResults,
  fetchHoldingsProbes
};
